export default "__VITE_ASSET__feadeef3__"